import { useLocation, useNavigate, useParams } from "react-router-dom";


// export function withParam( Component ) {
//   return ( props ) =>  <Component { ...props } navigate={ useNavigate() } location={ useLocation() } params={useParams()} />;
// }
export function withHOCParam( Component ) {
  return ( props ) =>  <Component { ...props } params={useParams()} />;
}